import React from "react";

import { OWNER_STATUS } from "../../../_metronic/utils/utils";

const StatusComponent = ({ value, label }) => {
	let style = {
		backgroundColor: "#EFF1F5",
		border: "1px solid #C6C6C6",
		fontWeight: 500,
		fontSize: "12px",
		lineHeight: "18px",
		color: "#57617C",
		minHeight: "22px",
		textAlign: "center",
		padding: "2px 8px",
		borderRadius: "4px",
		maxWidth: "110px",
	};
	let labelValue = value;
	if (value === OWNER_STATUS.ACCEPTED.key) {
		labelValue = OWNER_STATUS.ACCEPTED.title;
		style = {
			backgroundColor: "#EFF8E5",
			border: "1px solid #EFF8E5",
			fontWeight: 500,
			fontSize: "12px",
			lineHeight: "18px",
			color: "#62AC03",
			minHeight: "22px",
			textAlign: "center",
			padding: "2px 8px",
			borderRadius: "4px",
			maxWidth: "110px",
		};
	}
	if (value === OWNER_STATUS.INVITATION_SENT.key) {
		labelValue = OWNER_STATUS.INVITATION_SENT.title;
		style = {
			backgroundColor: "#DAEBFB",
			border: "1px solid #DAEBFB",
			fontWeight: 500,
			fontSize: "12px",
			lineHeight: "18px",
			color: "#338FEB",
			minHeight: "22px",
			textAlign: "center",
			padding: "2px 8px",
			borderRadius: "4px",
			maxWidth: "110px",
		};
	}
	if (value === OWNER_STATUS.REJECT.key) {
		labelValue = OWNER_STATUS.REJECT.title;
		style = {
			backgroundColor: "#FFEEEE",
			border: "1px solid #FFEEEE",
			fontWeight: 500,
			fontSize: "12px",
			lineHeight: "18px",
			color: "#F42222",
			minHeight: "22px",
			textAlign: "center",
			padding: "2px 8px",
			borderRadius: "4px",
			maxWidth: "110px",
		};
	}
	return (label || labelValue) && <div style={style} >{label ?? labelValue}</div>;
};

export default StatusComponent;
